/*
	Debug-mode: without Maps JS API, Places, Geocoding Google Maps SDK
		dealerLocatorDebug.disableMaps()
		dealerLocatorDebug.enableMaps()

		( localStorage):
			?dl_no_maps=1   disable
			?dl_no_maps=0   enable
 */

const STORAGE_KEY = 'dealer-locator:no-maps';

export function isMapsDisabled() {
	try {
		const params = new URLSearchParams(window.location.search);
		if (params.has('dl_no_maps')) {
			const value = params.get('dl_no_maps') !== '0';
			localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
			return value;
		}
		return localStorage.getItem(STORAGE_KEY) === '1';
	} catch {
		return false;
	}
}

function setMapsDisabled(value) {
	try {
		localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
	} catch { }
	console.info(
		`[dealer-locator] Google Maps requests are now ${value ? 'DISABLED' : 'ENABLED'}. Reload the page to apply.`
	);
}


export function registerDebugHelper() {
	if (typeof window === 'undefined' || window.dealerLocatorDebug) return;

	window.dealerLocatorDebug = {
		enableMaps: () => setMapsDisabled(false),
		disableMaps: () => setMapsDisabled(true),
		isMapsDisabled,
	};
}
